<script>
export default {
  name: "vc-share-nl2br",
  functional: true,
  props: ["tag", "text", "classes", "attrs"],
  render: function(createElement, context) {
    return createElement(
      context.props.tag,
      {
        class: context.props.classes,
        attrs: context.props.attrs
      },
      (context.props.text !== undefined ? context.props.text : "")
        .split("\n")
        .reduce(function(previousValue, currentValue) {
          if (!Array.isArray(previousValue)) {
            return [previousValue, createElement("br"), currentValue];
          }
          return previousValue.concat([createElement("br"), currentValue]);
        })
    );
  }
};
</script>

<style></style>
